import api from './api';
import {
  LockerFloorListResponse,
  LockerAddonListResponse,
  LockerTypeListResponse,
  LockerSpaceListResponse,
  LockerFloor,
  LockerAddon,
  LockerType,
  LockerSpace
} from '../types/locker';

// Locker Floors
export const lockerFloorService = {
  getAll: async (workspaceId: string, params?: any): Promise<LockerFloorListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-floors`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ lockerFloor: LockerFloor }> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-floors/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ lockerFloor: LockerFloor }> => {
    const response = await api.post(`/workspaces/${workspaceId}/locker-floors`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ lockerFloor: LockerFloor }> => {
    const response = await api.put(`/workspaces/${workspaceId}/locker-floors/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/locker-floors/${id}`);
  },

  uploadLayout: async (workspaceId: string, floorId: string, layoutData: any): Promise<{ lockerFloor: any }> => {
    const response = await api.post(`/workspaces/${workspaceId}/locker-floors/${floorId}/layout`, layoutData);
    return response.data;
  }
};

// Locker Add-ons
export const lockerAddonService = {
  getAll: async (workspaceId: string, params?: any): Promise<LockerAddonListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-addons`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ lockerAddon: LockerAddon }> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-addons/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ lockerAddon: LockerAddon }> => {
    const response = await api.post(`/workspaces/${workspaceId}/locker-addons`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ lockerAddon: LockerAddon }> => {
    const response = await api.put(`/workspaces/${workspaceId}/locker-addons/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/locker-addons/${id}`);
  }
};

// Locker Types
export const lockerTypeService = {
  getAll: async (workspaceId: string, params?: any): Promise<LockerTypeListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-types`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ lockerType: LockerType }> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-types/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ lockerType: LockerType }> => {
    const response = await api.post(`/workspaces/${workspaceId}/locker-types`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ lockerType: LockerType }> => {
    const response = await api.put(`/workspaces/${workspaceId}/locker-types/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/locker-types/${id}`);
  }
};

// Locker Spaces
export const lockerSpaceService = {
  getAll: async (workspaceId: string, params?: any): Promise<LockerSpaceListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-spaces`, { params });
    return response.data;
  },

  getByFloor: async (workspaceId: string, floorId: string, params?: any): Promise<LockerSpaceListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-spaces/by-floor/${floorId}`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ lockerSpace: LockerSpace }> => {
    const response = await api.get(`/workspaces/${workspaceId}/locker-spaces/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ lockerSpace: LockerSpace }> => {
    const response = await api.post(`/workspaces/${workspaceId}/locker-spaces`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ lockerSpace: LockerSpace }> => {
    const response = await api.put(`/workspaces/${workspaceId}/locker-spaces/${id}`, data);
    return response.data;
  },

  bulkUpdate: async (workspaceId: string, updates: any[]): Promise<{ updated: number }> => {
    const response = await api.put(`/workspaces/${workspaceId}/locker-spaces/bulk-update`, { updates });
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/locker-spaces/${id}`);
  },

  bulkCreate: async (workspaceId: string, spaces: any[]): Promise<{ lockerSpaces: any[]; count: number; message: string }> => {
    const response = await api.post(`/workspaces/${workspaceId}/locker-spaces/bulk-create`, { spaces });
    return response.data;
  }
};
